import { PageRoutes, UserCenterRoutes } from '@/constants/PageRoutes'
import UserCenterView from '@/views/UserCenter/UserCenterView'
import type { RouteRecordRaw } from 'vue-router'
import { getKycRouter } from './kyc-router'

export const getCommonRouter = (): RouteRecordRaw[] => {
  return [
    {
      path: PageRoutes.Login,
      component: () => import('@/views/NotLoggedInUserView/LoginView'),
      meta: {
        title: '登录',
      },
    },
    {
      path: PageRoutes.Register,
      component: () => import('@/views/NotLoggedInUserView/RegisterView'),
      meta: {
        title: '注册',
      },
    },
    {
      path: PageRoutes.LoginInputPassword,
      component: () => import('@/views/NotLoggedInUserView/LoginInputPassword'),
      meta: {
        title: '登录-输入密码',
      },
    },
    {
      path: PageRoutes.PreForgetPassword,
      component: () => import('@/views/NotLoggedInUserView/PreForgetPassword'),
      meta: {
        title: '忘记密码',
      },
    },
    {
      path: PageRoutes.ResetPassword,
      component: () => import('@/views/NotLoggedInUserView/ResetPassword'),
      meta: {
        title: '重置密码',
      },
    },
    {
      path: PageRoutes.RegisterPassword,
      component: () => import('@/views/NotLoggedInUserView/RegisterPassword'),
      meta: {
        title: '注册-设置密码',
      },
    },
    {
      path: PageRoutes.RegisterAuthEmail,
      component: () => import('@/views/NotLoggedInUserView/RegisterAuthEmail'),
      meta: {
        title: '注册-邮箱验证',
      },
    },
    {
      path: PageRoutes.RegisterAuthMobile,
      component: () => import('@/views/NotLoggedInUserView/RegisterAuthMobile'),
      meta: {
        title: '注册-手机验证',
      },
    },
    {
      path: PageRoutes.UserCenter,
      component: UserCenterView,
      meta: {
        title: '用户中心',
      },
      children: [
        {
          path: UserCenterRoutes.AssetFund,
          component: () => import('@/views/UserCenter/AssetFund'),
          meta: {
            title: '资金账户',
          },
        },
        {
          path: UserCenterRoutes.AssetContract,
          component: () => import('@/views/UserCenter/AssetContract'),
          meta: {
            title: '合约账户',
          },
        },
        {
          path: UserCenterRoutes.AssetFinance,
          component: () => import('invest-financial/src/views/UserCenter/FinancialAccount'),
          meta: {
            title: '理财',
          },
        },
        {
          path: UserCenterRoutes.AssetBill,
          component: () => import('@/views/UserCenter/AccountBill'),
          meta: {
            title: '账单',
          },
        },
        {
          path: UserCenterRoutes.FinancialHistory,
          component: () => import('invest-financial/src/views/UserCenter/FinancialHistory'),
          meta: {
            title: '理财账单',
          },
        },
        {
          path: UserCenterRoutes.PromotionCenter,
          component: () => import('@/views/UserCenter/PromotionCenter/PromotionCenter.tsx'),
          meta: {
            title: '推广中心',
          },
        },
        {
          path: UserCenterRoutes.MyInvitation,
          component: () => import('@/views/UserCenter/PromotionCenter/MyInvitation.tsx'),
          meta: {
            title: '我的邀请',
          },
        },
        {
          path: UserCenterRoutes.FriendDetails,
          component: () => import('@/views/UserCenter/PromotionCenter/FriendDetails.tsx'),
          meta: {
            title: '好友详情',
          },
        },
        {
          path: UserCenterRoutes.SpotOrder,
          component: () => import('@/views/UserCenter/SpotOrder'),
          meta: {
            title: '现货订单',
          },
        },
        {
          path: UserCenterRoutes.ContractOrder,
          component: () => import('@/views/UserCenter/ContractOrder'),
          meta: {
            title: '合约订单',
          },
        },
        {
          path: UserCenterRoutes.UserOverview,
          component: () => import('@/views/UserCenter/UserOverview'),
          meta: {
            title: '个人概览',
          },
        },
        ...getKycRouter(),
        {
          path: UserCenterRoutes.SecuritySettings,
          component: () => import('@/views/UserCenter/SecuritySettings'),
          meta: {
            title: '安全设置',
          },
        },
        {
          path: UserCenterRoutes.Recharge,
          component: () => import('@/views/UserCenter/RechargeView'),
          meta: {
            title: '充值',
          },
        },
        {
          path: UserCenterRoutes.Withdraw,
          component: () => import('@/views/UserCenter/WithdrawView'),
          meta: {
            title: '提币',
          },
        },
      ],
    },
    {
      path: `${PageRoutes.HelpCenter}/:lang?`,
      component: () => import('@/views/HelpCenter/HelpCenter'),
      meta: {
        title: '帮助中心',
      },
    },
  ]
}
